"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "viadana": {
    "8275b839": [{
      "hkey": "bf3a275b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cogozzo": [{
      "hkey": "bf3a275b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "viadana"
    }],
    "ee2f2272": [{
      "hkey": "6b2c5cb5",
      "slug": "cicognara-cogozzo",
      "name": "Cicognara-Cogozzo",
      "primary": true,
      "skipSearch": false
    }],
    "cicognara": [{
      "hkey": "6b2c5cb5",
      "slug": "cicognara-cogozzo",
      "name": "Cicognara-Cogozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;